import { useEffect, useState } from "react";
import ConnectButton from "@/components/ConnectButton";
import TierRing from "./components/ProgressRing";
import RewardDropdown from "./components/RewardDropdown";
import style from "./style.module.scss";
import toast from "react-hot-toast";
import sdk from "@farcaster/miniapp-sdk";
import { UserContext } from "@/types/user";
import { getClaimStatus, ClaimResponse, postClaim } from "@/api/claim";
import { useAccount } from "wagmi";
import { DEMO_ADDRESS, DEMO_USER } from "@/constants/demo";
import { TOTAL_SUPPLY } from "@/constants/mint";
import { formatNumber } from "@/utils/string";

type Props = {
  isWhitelistOver: boolean;
};

const PreclaimView = ({ isWhitelistOver }: Props) => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const { isConnected, address } = useAccount();
  const [user, setUser] = useState<UserContext>();
  const [extraData, setExtraData] = useState<ClaimResponse>();
  const [loading, setLoading] = useState(false);
  const connected = import.meta.env.PROD ? isConnected : true;

  const handleClaim = async () => {
    if (import.meta.env.PROD) {
      if (!user || !address) return;
    } else if (!user) return;

    setLoading(true);
    try {
      // Show loading state for better UX
      await new Promise((resolve) => setTimeout(resolve, 1000));
      const { fid } = user;
      // Then call API
      const data = await postClaim(
        fid,
        import.meta.env.PROD && address ? address : DEMO_ADDRESS
      );
      setExtraData(data);

      setShowSuccessModal(true);
    } catch (err) {
      console.error("Something went wrong while joining:", err);
      toast.error("Something went wrong while joining. Try again", {
        duration: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchUser = async () => {
      setLoading(true);
      try {
        const context = import.meta.env.PROD
          ? (await sdk.context).user
          : DEMO_USER;
        setUser(context);
        const data = await getClaimStatus(context.fid);
        setExtraData(data);
      } catch (err) {
        console.error("Unable to load user data:", err);
        toast.error("Unable to load user data. Try again later", {
          duration: 3000,
        });
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, []);

  const handleCloseModal = () => {
    setShowSuccessModal(false);
  };

  if (!connected)
    return (
      <div className="main">
        <div className={style.wrapperImg}>
          <img src="/images/connect-wallet.png" alt="" className={style.img} />
        </div>
        <ConnectButton />
      </div>
    );

  return (
    <main className="main">
      <div className={style.kawaiiHeader}>
        <h2 className={style.kawaiiTitle}>Free Mint</h2>
        <div className={style.tierText}>
          Total supply: {formatNumber(TOTAL_SUPPLY)}
        </div>
        <TierRing tier={1} centerImage={user?.pfpUrl} size={300} />
        <div className={style.mintTime}>
          Mint Time: 08:00 AM ET on 20 Nov 2025
        </div>
      </div>
      <RewardDropdown
        user={user}
        loading={loading}
        showSuccessModal={showSuccessModal}
        claimed={extraData?.claimed}
        handleClaim={handleClaim}
        handleCloseModal={handleCloseModal}
        buttonClass={`button-flat button-flat-xl ${style.freeToClaimButton}`}
        isWhitelistOver={isWhitelistOver}
      />
    </main>
  );
};

export default PreclaimView;
